var $e38fdd3d3b697565$exports = {};
let $e38fdd3d3b697565$var$periodText;
let $e38fdd3d3b697565$var$endTimeText;
let $e38fdd3d3b697565$var$nextText;
let $e38fdd3d3b697565$var$schedulenameElement;
let $e38fdd3d3b697565$var$lastData;
// Gets data from /today/now/near
let $e38fdd3d3b697565$var$progressIntervals = [];
function $e38fdd3d3b697565$var$display(data) {
    if (!data) return;
    for (const interval of $e38fdd3d3b697565$var$progressIntervals)clearInterval(interval);
    $e38fdd3d3b697565$var$progressIntervals = [];
    if (data[2] && (!data[1] || !data[1][0] || data[1][0].kind !== 'BeforeSchool')) {
        getel('next_period').innerHTML = getel('next_period_template').innerHTML;
        put_period_to_element(getel('next_period'), data[2]);
        getel('next_parent').style.display = 'block';
    } else getel('next_parent').style.display = 'none';
    const template = getel('current_period_time_template');
    const parent = getel('current_parent');
    parent.innerHTML = '';
    if (data[1][0]) {
        if ($e38fdd3d3b697565$var$lastData) {
            const oldPeriods = $e38fdd3d3b697565$var$lastData.flat().filter(Boolean).map((x)=>x.friendly_name);
            const nowPeriods = new Set(data[1].filter(Boolean).map((x)=>x.friendly_name));
            if (oldPeriods.every((x)=>!nowPeriods.has(x))) $e38fdd3d3b697565$var$schedule();
        }
        for (const i of data[1]){
            const new_element = document.createElement('div');
            new_element.innerHTML = template.innerHTML;
            const didPutProgress = put_period_to_element(new_element, i);
            parent.append(new_element);
            if (didPutProgress) {
                const size = Number.parseFloat(document.defaultView.getComputedStyle(new_element, null).fontSize.slice(0, -2));
                const svg = new_element.querySelector('.progress-ring');
                svg.setAttribute('width', size);
                svg.setAttribute('height', size);
                const circle = new_element.querySelector('.progress-ring__circle');
                const border = new_element.querySelector('.progress-ring__border');
                circle.setAttribute('cx', size / 2);
                circle.setAttribute('cy', size / 2);
                circle.setAttribute('r', size / 4 - 1);
                circle.setAttribute('stroke-width', size / 2 - 2);
                border.setAttribute('cx', size / 2);
                border.setAttribute('cy', size / 2);
                border.setAttribute('r', size / 2 - 2);
                $e38fdd3d3b697565$var$progressIntervals.push(setInterval(()=>{
                    update_progress_circular(i, new_element);
                }, 1000));
                update_progress_circular(i, new_element);
            }
        }
    } else {
        const new_element = document.createElement('div');
        new_element.innerHTML = template.innerHTML;
        put_period_to_element(new_element, null);
        parent.append(new_element);
    }
    $e38fdd3d3b697565$var$lastData = data;
}
window.addEventListener('resize', ()=>$e38fdd3d3b697565$var$display($e38fdd3d3b697565$var$lastData));
async function $e38fdd3d3b697565$var$schedule() {
    const day = await get('/api/v1/today');
    if (!day) return;
    $e38fdd3d3b697565$var$setColors(bytes_to_color(day.color));
    if (day.periods.length > 0) {
        $e38fdd3d3b697565$var$schedulenameElement.innerHTML = `${day.friendly_name}`;
        $e38fdd3d3b697565$var$schedulenameElement.style.display = 'inline-block';
    } else {
        $e38fdd3d3b697565$var$schedulenameElement.innerHTML = '';
        $e38fdd3d3b697565$var$schedulenameElement.style.display = 'none';
    }
}
function $e38fdd3d3b697565$var$setColors(color) {
    if (!config.use_schedule_color) return;
    color ??= getCookie('schedule_color');
    if (color) setCookie('schedule_color', color, new Date().setHours(24, 0, 0, 0));
    document.body.style.setProperty('--background_color', color || config.background_color);
    document.body.style.setProperty('--background_text_color', color ? black_or_white(color) : config.background_text_color);
}
$e38fdd3d3b697565$var$setColors();
window.addEventListener('load', ()=>{
    $e38fdd3d3b697565$var$periodText = document.querySelector('#period');
    $e38fdd3d3b697565$var$endTimeText = document.querySelector('#end_time');
    $e38fdd3d3b697565$var$nextText = document.querySelector('#next');
    $e38fdd3d3b697565$var$schedulenameElement = document.querySelector('#schedulename');
    go($e38fdd3d3b697565$var$display);
    $e38fdd3d3b697565$var$schedule();
});


//# sourceMappingURL=frontend.c7c4e242.js.map
